// //Copyright © 2021 Cloudcontainers b.v. - All Rights Reserved
import client, { getData } from '../client';

export default {
	getLists(params) {
		return client.get('/compliancy', { params }).then(getData);
	}
};
